module.exports = __webpack_public_path__ + "img/10867_L.4aaec693.png";